import {configureStore} from '@reduxjs/toolkit';
import customer from './customerSlice';

const store = configureStore({
    reducer: {
        CUSTOMER: customer.reducer,
    }
})

export default store;